module.exports = __webpack_public_path__ + "img/icon_5.8e2fa8f5.png";